// SEO-optimised blog posts targeting Lucknow long-tail searches
export const blogPosts = [
  {
    slug: "kids-dentist-in-lucknow-pediatric-dentistry-guide",
    title: "Pediatric Dentistry in Lucknow: A Parent's Guide to Kids Dental Care (2026)",
    excerpt: "When to take your child for their first dental visit, what pediatric treatments really cost in Lucknow, and how to make dental visits fear-free.",
    category: "Pediatric Dentistry",
    readTime: "6 min read",
    date: "April 8, 2026",
    cover: "https://images.pexels.com/photos/8224633/pexels-photo-8224633.jpeg",
    author: "Dr. Anshu Singh",
    keywords: "kids dentist lucknow, pediatric dentist lucknow, child dental clinic lucknow, best kids dentist lucknow, dental care for children lucknow",
    seoDescription: "Complete parent's guide to pediatric dentistry in Lucknow — first visit age, cavity fillings, fluoride, sealants and costs at Dr. Khurana's Dental & Aesthetic Clinic.",
    content: [
      { type: "p", text: "As a parent, one of the most common questions we hear at Dr. Khurana's Dental & Aesthetic Clinic in Lucknow is: 'When should my child first see a dentist?' The answer surprises most parents — it's around the first birthday, or within 6 months of the first tooth appearing." },
      { type: "h2", text: "When Should Your Child Start Seeing a Dentist?" },
      { type: "p", text: "The Indian Dental Association and the American Academy of Pediatric Dentistry both recommend the first dental visit by age 1. Early visits establish a 'dental home' and prevent cavities before they start." },
      { type: "h2", text: "Common Pediatric Dental Treatments & Costs in Lucknow" },
      { type: "table", head: ["Treatment", "What It's For", "Cost in Lucknow"], rows: [
        ["Routine check-up + cleaning", "Prevention", "₹500 – ₹1,200"],
        ["Fluoride application", "Cavity prevention", "₹800 – ₹1,500"],
        ["Pit & fissure sealants (per tooth)", "Molar protection", "₹500 – ₹900"],
        ["Composite filling (baby tooth)", "Small cavity", "₹800 – ₹1,800"],
        ["Pulpectomy (baby root canal)", "Deep cavity, pulp involvement", "₹2,500 – ₹4,500"],
        ["Stainless steel crown", "Large cavity restoration", "₹2,000 – ₹3,500"],
        ["Space maintainer", "Early tooth loss", "₹3,500 – ₹6,000"],
        ["Habit-breaking appliance", "Thumb-sucking, tongue-thrusting", "₹5,000 – ₹9,000"],
      ] },
      { type: "h2", text: "How We Make Dental Visits Fear-Free for Children" },
      { type: "ul", items: [
        "Tell-show-do technique — kids see and touch every instrument before it's used",
        "No white coats — a warm, cartoon-friendly clinic environment",
        "Parents can stay in the room throughout the visit",
        "Every visit ends with a small reward",
      ] },
      { type: "h2", text: "How Often Should Kids Visit the Dentist?" },
      { type: "p", text: "Every 6 months is the gold standard — this way we catch cavities when they're tiny, apply protective fluoride and sealants, and track jaw growth for early orthodontic issues (like crowding, cross-bite or thumb-sucking damage)." },
      { type: "h2", text: "What Are the Warning Signs I Should Watch For?" },
      { type: "ul", items: [
        "White or brown spots on teeth (early cavities)",
        "Complaints of sensitivity to cold or sweets",
        "Persistent thumb-sucking after age 4",
        "Mouth breathing while asleep",
        "Bleeding gums while brushing",
        "Baby teeth not falling out on time (age 6+)",
      ] },
      { type: "cta", text: "Book your child's first happy dental visit" },
    ],
  },
  {
    slug: "laser-gum-treatment-lucknow-cost-benefits",
    title: "Laser Gum Treatment in Lucknow: Cost, Benefits & What to Expect",
    excerpt: "Bleeding gums, receding gum line or dark gums? Modern laser gum therapy is painless, bloodless and finished in a single sitting. A full 2026 guide.",
    category: "Gum Treatment",
    readTime: "6 min read",
    date: "April 2, 2026",
    cover: "https://images.pexels.com/photos/31188655/pexels-photo-31188655.jpeg",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "laser gum treatment lucknow, gum surgery lucknow, gum bleaching lucknow, periodontal treatment lucknow, laser dentistry lucknow, bleeding gums treatment lucknow",
    seoDescription: "Laser gum treatment in Lucknow — cost, procedure, benefits over traditional gum surgery. Painless, bloodless and single-sitting periodontal care.",
    content: [
      { type: "p", text: "Nearly 1 in 2 adults in India live with some form of gum disease. Bleeding while brushing, bad breath, or gums pulling away from teeth are all early signs. The good news — modern laser gum treatment can be used for selected gum procedures, depending on the diagnosis and treatment required." },
      { type: "h2", text: "What Is Laser Gum Treatment?" },
      { type: "p", text: "Laser gum treatment uses a soft-tissue dental laser to remove infected gum tissue, kill bacteria deep inside gum pockets, and stimulate healing — without a scalpel, without sutures, and with almost no bleeding." },
      { type: "h2", text: "Laser Gum Treatment Cost in Lucknow (2026)" },
      { type: "table", head: ["Procedure", "What It Treats", "Approx. Cost"], rows: [
        ["Laser bacterial reduction", "Bleeding gums, early gum disease", "₹3,000 – ₹6,000 per session"],
        ["Laser scaling & root planing (per quadrant)", "Moderate gum disease", "₹4,000 – ₹8,000"],
        ["Laser gum depigmentation", "Dark / pigmented gums", "₹6,000 – ₹12,000 (upper + lower)"],
        ["Laser crown lengthening (gummy smile)", "Gummy smile correction", "₹8,000 – ₹15,000"],
        ["Full-mouth laser periodontal therapy", "Advanced gum disease", "₹18,000 – ₹35,000"],
        ["Laser frenectomy", "Tongue-tie / lip-tie", "₹3,500 – ₹6,000"],
      ] },
      { type: "h2", text: "Benefits Over Traditional Gum Surgery" },
      { type: "ul", items: [
        "Comfort-focused — local anaesthesia may be used depending on the procedure and patient comfort",
        "Bloodless — the laser seals blood vessels as it works",
        "No stitches, no dressings, no dental packing",
        "Single-sitting for most cases (30–45 min)",
        "Helps reduce bacteria in gum pockets as part of periodontal treatment",
        "Return to work / eat normally the same day",
      ] },
      { type: "h2", text: "Who Is a Candidate for Laser Gum Treatment?" },
      { type: "ol", items: [
        "Patients with bleeding gums or bad breath",
        "Adults with moderate periodontitis and 4–6 mm pockets",
        "Anyone with pigmented / dark gums who wants pink gums",
        "Patients with gummy smile who want gum contouring",
        "Diabetics who need low-bleed, low-risk procedures",
      ] },
      { type: "h2", text: "Recovery & Aftercare" },
      { type: "p", text: "Most patients return to normal eating in 24 hours. We recommend a soft diet for 2 days, avoid spicy food and rinse with prescribed mouthwash. Follow-up in 2 weeks to confirm healing." },
      { type: "cta", text: "Book a laser gum consultation today" },
    ],
  },
  {
    slug: "wisdom-tooth-extraction-lucknow-cost-recovery",
    title: "Wisdom Tooth Extraction in Lucknow: Cost, Recovery & When You Really Need It",
    excerpt: "Do you actually need your wisdom tooth removed? Costs of simple vs surgical extraction, recovery timeline and what to eat afterwards.",
    category: "Oral Surgery",
    readTime: "7 min read",
    date: "March 26, 2026",
    cover: "https://images.unsplash.com/photo-1522849696084-818b29dfe210?w=1200&q=80",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "wisdom tooth extraction lucknow, wisdom tooth removal lucknow, wisdom tooth surgery lucknow, impacted wisdom tooth lucknow, wisdom tooth cost lucknow, third molar extraction",
    seoDescription: "Wisdom tooth extraction in Lucknow — cost of simple vs surgical removal, recovery timeline, aftercare and warning signs you need it removed.",
    content: [
      { type: "p", text: "Wisdom teeth (third molars) usually erupt between 17 and 25 years of age. In many Indian jaws there just isn't enough space, which leads to pain, food-packing, cheek biting and even cyst formation. Here's a straightforward guide to wisdom tooth extraction in Lucknow." },
      { type: "h2", text: "Do You Really Need Your Wisdom Tooth Removed?" },
      { type: "p", text: "Not always. If the wisdom tooth is fully erupted, upright and easy to clean — we usually leave it alone. Removal is only recommended in specific cases:" },
      { type: "ul", items: [
        "Repeated pain, swelling or infection around the tooth",
        "Impaction (tooth stuck against the tooth in front)",
        "Food-packing and decay in the wisdom tooth or the tooth in front",
        "Cyst or bone lesion around the tooth on X-ray",
        "Before orthodontic treatment to prevent crowding relapse",
        "Damage to the neighbouring second molar",
      ] },
      { type: "h2", text: "Wisdom Tooth Extraction Cost in Lucknow (2026)" },
      { type: "table", head: ["Type", "Description", "Approx. Cost"], rows: [
        ["Simple extraction", "Fully erupted, straight wisdom tooth", "₹1,500 – ₹3,000"],
        ["Surgical extraction (soft tissue impaction)", "Gum covers part of tooth", "₹4,500 – ₹7,000"],
        ["Surgical extraction (bony impaction)", "Tooth stuck in jawbone", "₹6,000 – ₹9,500"],
        ["Complex mesio-angular impaction", "Requires bone removal + tooth sectioning", "₹8,000 – ₹12,500"],
        ["OPG X-ray (compulsory pre-op)", "Panoramic dental X-ray", "₹500 – ₹800"],
        ["CBCT 3D scan (deep cases)", "3D imaging near nerve", "₹2,000 – ₹3,500"],
      ] },
      { type: "h2", text: "The Procedure — Step by Step" },
      { type: "ol", items: [
        "OPG X-ray to assess position, roots and proximity to the nerve",
        "Local anesthesia — tooth and surrounding area go completely numb",
        "A small gum flap is lifted (only in surgical cases)",
        "Tooth is sectioned into small pieces if impacted, and removed",
        "The socket is cleaned, medication is placed, 2–3 dissolvable sutures",
        "You go home in 45–60 minutes with a written aftercare sheet",
      ] },
      { type: "h2", text: "Recovery Timeline" },
      { type: "table", head: ["Day", "What to Expect"], rows: [
        ["Day 1", "Numbness for 3–4 hours. Bite on gauze. Mild soreness starts."],
        ["Day 2–3", "Peak swelling. Ice packs, painkiller as prescribed."],
        ["Day 4–5", "Swelling reduces. Soft diet continues."],
        ["Day 7", "Suture removal / dissolving. Back to routine eating."],
        ["Week 2", "Complete healing. Any restrictions lifted."],
      ] },
      { type: "h2", text: "What to Eat After Wisdom Tooth Removal" },
      { type: "ul", items: [
        "First 24 hrs: cold liquids — milkshakes, cold coffee (no straw), buttermilk",
        "Day 2–3: soft foods — dal khichdi, curd rice, mashed potato, scrambled egg",
        "Avoid for 1 week: spicy food, hot tea, chewing on that side, alcohol, smoking",
      ] },
      { type: "h2", text: "Warning Signs to Watch For" },
      { type: "p", text: "Contact us immediately if you have severe pain after day 3 (may be a dry socket), swelling that gets worse instead of better, fever, or heavy bleeding that doesn't stop with pressure." },
      { type: "cta", text: "Book a wisdom tooth consultation and OPG" },
    ],
  },
  {
    slug: "cost-of-dental-implants-in-lucknow-2026-guide",
    title: "Cost of Dental Implants in Lucknow – 2026 Price Guide",
    excerpt: "How much do dental implants really cost in Lucknow? A transparent 2026 price breakdown by brand, procedure and full‑mouth solutions.",
    category: "Dental Implants",
    readTime: "6 min read",
    date: "March 12, 2026",
    cover: "https://images.pexels.com/photos/6502305/pexels-photo-6502305.jpeg",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "dental implants cost lucknow, dental implant price lucknow, cheap dental implants lucknow, full mouth dental implants cost",
    seoDescription: "Detailed 2026 cost guide for dental implants in Lucknow. Single tooth, full-arch, All-on-4 & All-on-6 pricing at Dr. Khurana's Dental & Aesthetic Clinic.",
    content: [
      { type: "p", text: "Dental implants have quietly become the most popular way to replace missing teeth in Lucknow — and for good reason. They look natural, function like real teeth, and last decades when planned well. But the first question every patient asks us at Dr. Khurana’s Dental & Aesthetic Clinic is the same: how much do dental implants cost in Lucknow in 2026?" },
      { type: "h2", text: "Single Tooth Dental Implant Cost in Lucknow (2026)" },
      { type: "p", text: "A single dental implant with crown in Lucknow typically ranges between ₹24,000 and ₹60,000 at our clinic, depending on the implant system, crown material and individual clinical requirements." },
      { type: "table", head: ["Implant System", "PFM", "DMLS PFM", "Zirconia", "E-max"], rows: [
        ["Standard (Israeli) — Adin / Noris / MIS / BioLine / Alpha-Bio", "₹24,000 – ₹32,000", "₹27,000 – ₹36,000", "₹30,000 – ₹42,000", "₹33,000 – ₹45,000"],
        ["Value (Korean) — Osstem / Dentium / DIO / Dentis / NeoBiotech / Cowellmedi", "₹26,000 – ₹36,000", "₹29,000 – ₹40,000", "₹33,000 – ₹46,000", "₹36,000 – ₹50,000"],
        ["Premium — Ankylos / bredent / Implant Swiss / Nobel Biocare / Straumann / Zimmer / BioHorizons", "₹35,000 – ₹50,000", "₹38,000 – ₹54,000", "₹42,000 – ₹60,000", "₹45,000 – ₹60,000"],
      ] },
      { type: "p", text: "All prices at Dr. Khurana’s are written on paper before we start treatment — no hidden charges, no surprise add‑ons." },
      { type: "h2", text: "Full Mouth Dental Implants Cost in Lucknow" },
      { type: "p", text: "For patients missing most or all of their teeth, we recommend either All‑on‑4 or All‑on‑6. These give you a fixed set of teeth in as little as 3‑5 days." },
      { type: "ul", items: [
        "All-on-4 (single arch): ₹1,80,000 – ₹3,50,000",
        "All-on-6 (single arch): ₹2,80,000 – ₹4,50,000",
        "All-on-4 (both arches): ₹3,60,000 – ₹7,00,000",
        "All-on-6 (both arches): ₹5,60,000 – ₹9,00,000",
      ] },
      { type: "h2", text: "What Affects the Cost?" },
      { type: "ul", items: [
        "Implant brand and system used",
        "Bone density — whether a bone graft or sinus lift is required",
        "Type of crown — conventional PFM, DMLS metal-ceramic, zirconia or E-max",
        "CBCT 3D scans and digital planning",
        "Guided vs. freehand surgery",
      ] },
      { type: "h2", text: "Do EMI Options Exist for Dental Implants in Lucknow?" },
      { type: "p", text: "EMI and financing options for dental implant treatment are currently being introduced at our clinic. Please contact us to check current availability and applicable terms." },
      { type: "h2", text: "How Long Do Implants Last?" },
      { type: "p", text: "With good hygiene and 6‑monthly follow‑ups, a well‑placed implant should easily last 20–25 years — the crown on top is typically replaced every 10–15 years." },
      { type: "cta", text: "Get a personal implant quote in 24 hours" },
    ],
  },
  {
    slug: "best-dentist-in-lucknow-how-to-choose",
    title: "Best Dentist in Lucknow: How to Choose in 2026",
    excerpt: "A no‑nonsense guide to finding the right dentist in Lucknow — what qualifications, technology and red flags to look for.",
    category: "Patient Guide",
    readTime: "5 min read",
    date: "February 28, 2026",
    cover: "https://images.pexels.com/photos/3762453/pexels-photo-3762453.jpeg",
    author: "Dr. Anshu Singh",
    keywords: "best dentist in lucknow, top dental clinic lucknow, dentist near me lucknow, best dental doctor lucknow",
    seoDescription: "How to find the best dentist in Lucknow in 2026 — qualifications, tech, red flags and questions to ask before booking.",
    content: [
      { type: "p", text: "Searching for the best dentist in Lucknow can feel overwhelming — there are hundreds of clinics online, all claiming the same thing. Here is a simple checklist we recommend to every patient walking in for a second opinion." },
      { type: "h2", text: "1. Check the Doctor’s Qualifications" },
      { type: "p", text: "Look for a BDS (Bachelor of Dental Surgery) at minimum, and ideally an MDS (Master of Dental Surgery) in the specific area you need care for — for example, MDS in Prosthodontics for implants, MDS in Orthodontics for braces or Invisalign." },
      { type: "h2", text: "2. Ask About the Technology Used" },
      { type: "p", text: "A modern Lucknow clinic in 2026 should have digital X‑rays, an intra‑oral scanner, rotary endodontic systems, and ideally a CBCT machine for implant planning. If the clinic still uses only manual film X‑rays, quality suffers." },
      { type: "h2", text: "3. Sterilisation & Hygiene" },
      { type: "p", text: "Ask to see the autoclave, single‑use instruments and disposable barriers. A good dentist will happily show you." },
      { type: "h2", text: "4. Transparent, Written Estimates" },
      { type: "p", text: "You should always receive a written treatment plan with a price for every step — not a verbal 'we will see later'. Beware clinics that quote much cheaper prices upfront and then add hidden costs mid‑treatment." },
      { type: "h2", text: "5. Google Reviews & Real Patient Photos" },
      { type: "p", text: "Look for at least 100+ Google reviews with detail and photos, not just ‘Nice clinic’. Check that reviews are spread out over years, not all posted in one week." },
      { type: "h2", text: "Red Flags to Avoid" },
      { type: "ul", items: [
        "Prices that seem too good to be true (₹5,000 implant packages usually mean re‑used or unbranded implants)",
        "No CBCT / 3D scan before an implant is placed",
        "Pressure to start treatment the same day",
        "No consent form or written estimate",
      ] },
      { type: "cta", text: "Book a second‑opinion consultation — free of cost" },
    ],
  },
  {
    slug: "invisalign-vs-braces-lucknow",
    title: "Invisalign vs Metal Braces in Lucknow: Which Is Right for You?",
    excerpt: "Both work — but cost, treatment time and lifestyle are very different. A clear comparison from Dr. Anshu Singh, Orthodontist.",
    category: "Orthodontics",
    readTime: "7 min read",
    date: "February 10, 2026",
    cover: "https://images.unsplash.com/photo-1695275857301-19e5a9995108?w=1200&q=80",
    author: "Dr. Anshu Singh",
    keywords: "invisalign lucknow, braces lucknow, clear aligners lucknow, invisalign cost lucknow, best orthodontist lucknow",
    seoDescription: "Detailed comparison of Invisalign vs metal braces in Lucknow — cost, treatment time, comfort, best fit for adults and teens.",
    content: [
      { type: "p", text: "If you’re considering straightening your teeth in Lucknow, you have two main routes: traditional braces or clear aligners like Invisalign. Both work brilliantly — but they suit different people, budgets and lifestyles." },
      { type: "h2", text: "Quick Comparison" },
      { type: "table", head: ["Feature", "Metal Braces", "Invisalign"], rows: [
        ["Visibility", "Highly visible", "Nearly invisible"],
        ["Treatment time", "12–36 months", "6–24 months"],
        ["Cost in Lucknow (2026)", "₹35,000 – ₹70,000", "₹1,50,000 – ₹3,50,000"],
        ["Removability", "Fixed", "Removable for eating & brushing"],
        ["Best for", "Complex cases, teens", "Adults, mild‑moderate cases"],
      ] },
      { type: "h2", text: "When Invisalign Wins" },
      { type: "p", text: "For working professionals in Lucknow who don’t want visible metal in meetings, weddings or on Instagram — Invisalign is the clear winner. You get a 3D preview of your final smile before you start, and each aligner is changed every 7–10 days." },
      { type: "h2", text: "When Braces Win" },
      { type: "p", text: "For complex bite corrections, teenagers still growing, or severely crowded teeth, fixed braces (metal or ceramic) still give the orthodontist the most control — and cost significantly less." },
      { type: "h2", text: "How Long Does Each Take at Our Clinic?" },
      { type: "p", text: "On average, our Invisalign patients finish in 12–14 months and braces patients in 18–22 months. Every case at Dr. Khurana’s Dental & Aesthetic Clinic starts with a digital intra‑oral scan and a written treatment timeline." },
      { type: "cta", text: "Get a free digital smile preview" },
    ],
  },
  {
    slug: "root-canal-treatment-lucknow-what-to-expect",
    title: "Root Canal Treatment in Lucknow: Cost, Steps & What to Expect",
    excerpt: "Everything you need to know about a modern, single‑sitting root canal in Lucknow — pain, cost, longevity and aftercare.",
    category: "Root Canal",
    readTime: "5 min read",
    date: "January 22, 2026",
    cover: "https://images.pexels.com/photos/6502306/pexels-photo-6502306.jpeg",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "root canal treatment lucknow, rct cost lucknow, single sitting rct lucknow, painless root canal lucknow",
    seoDescription: "Root canal treatment in Lucknow — how it works, cost in 2026, painless single‑sitting RCT and recovery tips.",
    content: [
      { type: "p", text: "A root canal (RCT) is one of the most misunderstood procedures in dentistry. Ask most people and they will tell you it hurts. In reality, with modern rotary endodontics and single‑sitting protocols, the procedure is essentially painless." },
      { type: "h2", text: "How Much Does a Root Canal Cost in Lucknow?" },
      { type: "ul", items: [
        "Front tooth (single canal): ₹3,500 – ₹5,500",
        "Premolar (2 canals): ₹4,500 – ₹6,500",
        "Molar (3–4 canals): ₹6,000 – ₹8,500",
        "Retreatment / complex cases: ₹8,000 – ₹12,000",
        "Zirconia crown after RCT: ₹8,000 – ₹15,000",
      ] },
      { type: "h2", text: "Steps in a Modern Single‑Sitting Root Canal" },
      { type: "ol", items: [
        "Digital X‑ray and clinical exam",
        "Local anesthesia — the tooth is fully numb",
        "Rubber dam placement (keeps the area sterile)",
        "Cleaning and shaping the root canals using rotary files",
        "Filling the canals with biocompatible gutta‑percha",
        "Temporary filling on top, followed by a permanent crown in 1‑2 visits",
      ] },
      { type: "h2", text: "Will I Feel Any Pain?" },
      { type: "p", text: "During the procedure — no. Anesthesia ensures you feel only slight pressure. After the procedure — mild soreness for 24–48 hours which settles with a standard painkiller." },
      { type: "h2", text: "How Long Does an RCT Last?" },
      { type: "p", text: "When done correctly and protected by a crown, a root canal‑treated tooth can easily last 20+ years — essentially as long as your other teeth." },
      { type: "cta", text: "Book a painless single‑sitting RCT today" },
    ],
  },
  {
    slug: "smile-makeover-cost-lucknow",
    title: "Smile Makeover Cost in Lucknow: A Complete 2026 Guide",
    excerpt: "From basic whitening to full digital smile design with veneers — real costs, timelines and how to plan a smile makeover in Lucknow.",
    category: "Cosmetic Dentistry",
    readTime: "6 min read",
    date: "January 5, 2026",
    cover: "https://images.pexels.com/photos/16212691/pexels-photo-16212691.png",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "smile makeover lucknow, smile design lucknow, veneers cost lucknow, hollywood smile lucknow, cosmetic dentist lucknow",
    seoDescription: "How much does a smile makeover in Lucknow cost in 2026? Veneers, whitening, DSD, gum contouring — fully broken down.",
    content: [
      { type: "p", text: "A smile makeover is not a single treatment — it is a combination of small procedures designed together to change how your smile looks in photos, in the mirror and on camera. Here is what a smile makeover really costs in Lucknow in 2026." },
      { type: "h2", text: "Smile Makeover Options & Prices" },
      { type: "table", head: ["Procedure", "When it's used", "Approx. Cost"], rows: [
        ["In‑clinic Zoom whitening", "Yellow/stained teeth", "₹8,000 – ₹15,000"],
        ["Composite bonding (per tooth)", "Small chips, gaps", "₹2,500 – ₹5,000"],
        ["E‑max veneers (per tooth)", "Full smile design", "₹15,000 – ₹25,000"],
        ["Zirconia crowns (per tooth)", "Broken / RCT teeth", "₹8,000 – ₹15,000"],
        ["Gum contouring", "Gummy smile", "₹6,000 – ₹12,000 per session"],
        ["Digital Smile Design (DSD)", "3D preview before treatment", "₹5,000 (waived if you proceed)"],
      ] },
      { type: "h2", text: "How a Full Smile Makeover Works at Our Lucknow Clinic" },
      { type: "ol", items: [
        "Consultation and photos of your current smile",
        "Digital Smile Design — a 3D preview of your final smile",
        "Trial smile made from temporary resin — you approve before we start",
        "Preparation and precise ceramic veneers / crowns are placed",
        "Whitening, gum sculpting and polishing to finish",
      ] },
      { type: "h2", text: "How Much Does a Full Smile Makeover Cost Overall?" },
      { type: "p", text: "A typical smile makeover for the visible 8–10 front teeth (with veneers, whitening and DSD) ranges from ₹1,50,000 to ₹4,50,000. Simpler cases can be done under ₹50,000 with whitening + bonding." },
      { type: "cta", text: "Book a Digital Smile Design consultation" },
    ],
  },
  {
    slug: "dental-tourism-lucknow-nri-patients-guide",
    title: "Dental Tourism in Lucknow: A Complete Guide for NRI & International Patients",
    excerpt: "A practical guide for NRI and international patients considering planned dental treatment in Lucknow.",
    category: "Dental Tourism",
    readTime: "8 min read",
    date: "December 18, 2025",
    cover: "https://images.unsplash.com/flagged/photo-1568896909222-95dcd3b6b265?w=1200&q=80",
    author: "Dr. Jaspreet Singh Khurana",
    keywords: "dental tourism lucknow, nri dental treatment india, cheap dental implants india, dental tourism package india, dental treatment abroad india",
    seoDescription: "Dental tourism in Lucknow — planning implants, veneers and full-mouth dental treatment for NRI and international patients.",
    content: [
      { type: "p", text: "NRI and international patients considering dental treatment in Lucknow can contact our clinic in advance to discuss their dental concerns, expected treatment stages and approximate time required in India." },
      { type: "h2", text: "Why Lucknow?" },
      { type: "ul", items: [
        "Travel connections to Lucknow (LKO) from major Indian and international transit hubs",
        "A range of accommodation options for different budgets",
        "English-speaking clinical team and WhatsApp-based coordination",
        "Opportunity to explore Lucknow's heritage, Chikankari and Awadhi culture during suitable stages of the visit",
      ] },
      { type: "h2", text: "Planning Dental Treatment During Your Visit to Lucknow" },
      { type: "ol", items: [
        "Contact the clinic before travelling to discuss your dental concerns and available records",
        "Clinical examination and diagnostic imaging such as CBCT when required",
        "A treatment plan and estimated timeline based on the diagnosis",
        "Treatment appointments scheduled according to the procedure and healing requirements",
        "Review, provisional or final restoration stages as appropriate for the treatment",
        "Post-treatment instructions and follow-up planning before you return home",
      ] },
      { type: "h2", text: "How Much Will Treatment Cost?" },
      { type: "p", text: "Treatment cost depends on the procedure, materials used, number of teeth or implants involved and the complexity of the case. A personalised estimate can be provided after appropriate clinical evaluation and treatment planning." },
      { type: "h2", text: "Planning Safe Dental Care Away From Home" },
      { type: "p", text: "Treatment is planned according to the patient's diagnosis and clinical requirements. Diagnostic imaging, including CBCT, may be advised when appropriate, and the treatment timeline should allow for the procedure, healing and necessary review visits. Post-treatment follow-up can be coordinated after the patient returns home." },
      { type: "cta", text: "Discuss your dental treatment plan before travelling" },
    ],
  },
];

export const getPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);
